import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FatalError = () => /*#__PURE__*/_jsxs(ErrorMessage, {
  type: "badRequest",
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "conversations-error-reporting.fatalError.refreshThePage"
    })
  }), /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "conversations-error-reporting.fatalError.contactSupport"
    })
  })]
});
FatalError.displayName = 'FatalError';
export default FatalError;